<template>
  <list-meta
    v-bind="$attrs"
    v-on="$listeners"
    :limit="limit"
    class="ListFooter"
  >
    <span class="ListFooter-results">{{ $t("components.lists.resultsPerPage") }}</span>
    <el-button
      class="ListFooter-limit"
      type="text"
      v-for="l in limits"
      :key="l"
      v-text="l"
      @click="limitChanged(l)"
      :disabled="l === limit"
    ></el-button>
  </list-meta>
</template>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.ListFooter {
  width: 100%;
  &-limit {
    @extend .font-secondary;
    font-size: $font-size-base-alt;
    font-weight: $font-weight-normal;
  }

  &-results {
    font-size: $font-size-base;
  }
}
</style>

<script>
import ListMeta from './ListMeta'

/**
 * Pied de page d'une liste, incluant la pagination et le changement de limite d'éléments par page.
 */
export default {
  name: 'UbiListFooter',
  props: {
    /**
     * Nombre d'éléments par page
     */
    limit: { type: Number, default: 0 },
    /**
     * Liste de nombres possibles d'éléments par page
     */
    limits: { type: Array, default: () => [10, 20, 50] }
  },
  components: {
    ListMeta
  },
  methods: {
    limitChanged (newLimit) {
      this.$emit('update:limit', parseInt(newLimit, 10))
      this.$emit('input')
    }
  }
}
</script>
